import { CoasCarrousel } from "../components/coas_carrousel";
import { UCarrouselConfig, USocialSlider } from "../utilities/carousel.utils";
import { CoasVideoPreview } from "../components/coas_video";
class LandingPage {
    constructor() {
        this.landingCarouselId = 'landingCarouselId';
        this.socialSliderId = 'socialSliderId';
        this.containerVideoId = 'containerVideoId';
        console.log("START LANDING PAGE ....");
        this.initPageConfig();
    }
    initPageConfig() {
        // First landing carousel
        const landingPageCarrousel = document.getElementById(this.landingCarouselId);
        if (landingPageCarrousel) {
            const landingCarrousel = new CoasCarrousel(this.landingCarouselId, UCarrouselConfig);
            landingCarrousel.onInit();
        }
        // Socila landing Slider
        const socialCarrousel = document.getElementById(this.socialSliderId);
        if (socialCarrousel) {
            const socialSlider = new CoasCarrousel(this.socialSliderId, USocialSlider);
            socialSlider.onInit();
        }
        // Init video component
        const containerVideo = document.getElementById(this.containerVideoId);
        if (containerVideo) {
            const containerVideo = new CoasVideoPreview(this.containerVideoId);
            containerVideo.onInit();
        }
    }
}
window.addEventListener('load', function () {
    new LandingPage();
});
